import { Navigate, useLocation } from "react-router-dom";

export const ProtectedRoute = ({ user, redirectPath = "/", children }) => {
  const location = useLocation();
  
  // Check if user is authenticated by checking for token
  if (!user || !user.token) {
    // Include the current URL as a redirect parameter
    const redirectTo = `${redirectPath}?redirect=${encodeURIComponent(location.pathname + location.search)}`;
    return <Navigate to={redirectTo} replace />;
  }

  // Check if user needs onboarding (skip check for onboarding and account pages)
  const skipOnboardingPaths = ['/onboarding', '/account'];
  const shouldSkipOnboarding = skipOnboardingPaths.some(path => location.pathname.startsWith(path));
  
  if (user.onboarding_status === 'pending' && !shouldSkipOnboarding) {
    // User needs onboarding - redirect there with current path as redirect param
    const onboardingUrl = `/onboarding?redirect=${encodeURIComponent(location.pathname + location.search)}`;
    return <Navigate to={onboardingUrl} replace />;
  }

  return children;
};
